import { Component, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "fury-add-trainer-ticket",
  templateUrl: "./add-trainer-ticket.component.html",
  styleUrls: ["./add-trainer-ticket.component.scss"],
})
export class AddTrainerTicketComponent {
  alertDate: string = "";
  comment: string = "";

  constructor(private dialogRef: MatDialogRef<AddTrainerTicketComponent>) {}

  ngOnInit(): void {
    // Set default date to today in YYYY-MM-DD format (required by input[type=date])
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const dd = String(today.getDate()).padStart(2, "0");
    this.alertDate = `${yyyy}-${mm}-${dd}`;
  }

  onSubmit(): void {
    const payload = {
      alertDate: this.alertDate,
      comment: this.comment,
    };
    console.log("تسجيل التنبية:", payload);
    this.dialogRef.close(payload);
  }

  onClose(): void {
    this.dialogRef.close(null);
  }
}
